const formId = 'midfunnel-rcb-form';

const formStatusTracking = (status, attributes) => {
  window.GTMtracker.pushEvent({
    event: 'gtm_custom_click',
    data: {
      ...attributes,
      form_status: status,
      sub_product: 'listing_page',
      form_type: 'midfunnel_rcb_form',
      click_source: 'midfunnel_rcb_form',
      product: 'RCB',
    },
  });
};

const onInputFilled = (ele) => {
  try {
    const fieldName = ele?.name;
    const fieldData = ele?.value;

    if (!fieldData) return;

    if (window.GTMtracker) {
      window.GTMtracker.pushEvent({
        event: 'gtm_custom_click',
        data: {
          click_type: 'form_input_filled',
          click_text: fieldName,
          click_source: 'midfunnel_rcb_form',
          form_id: formId,
          form_value: fieldData,
        },
      });
    }
  } catch (e) {
    // Suppress error
  }
};

const trackActivity = ({ clickType, clickText }) => {
  try {
    if (window.GTMtracker) {
      window.GTMtracker.pushEvent({
        event: 'gtm_custom_click',
        data: {
          click_type: 'form_close',
          click_text: clickType,
          click_source: clickText,
          form_id: formId,
        },
      });
    }
  } catch (e) {
    // Suppress error
  }
};

/**
 * @function
 * To track all the form fields in the event registration form
 */
const trackAllFormFields = () => {
  const formEl = document.getElementById(formId);
  if (!formEl) {
    return;
  }

  const multiSelectOption = formEl.querySelectorAll(
    '.sr-multiselect__option-item',
  );

  for (let i = 0; i < multiSelectOption.length; i += 1) {
    multiSelectOption[i].classList.add('gtm-track-element');
    multiSelectOption[i].setAttribute('data-gtm-tracking-allowed', 'true');
  }

  /**
   * @function
   * @returns {string} - Number of fields already filled / total form fields
   *
   * While calucing fields already filled
   * we only took care of the fields which have some input
   * we are NOT validating those inputs
   */
  const findElementItem = () => {
    let updatedFields = 0;
    let totalFields = 0;

    /**
     * Ignore fields which are hidden
     */
    const formFields = formEl.querySelectorAll('.form-field:not(.hidden)');
    const multiFormFilds = formEl.querySelector('.sr-multiselect:not(.hidden)');

    if (formFields) {
      [...formFields].forEach((formField) => {
        const selectFieldEl = formField.querySelector(
          '.sr-select__value-input',
        );
        const inputEl = formField.querySelector('.form-input');

        totalFields += 1;

        if (inputEl?.value || selectFieldEl?.value) {
          updatedFields += 1;
        }
      });
    }
    if (multiFormFilds) {
      totalFields += 1;
      const inputOptionEl = multiFormFilds.getElementsByClassName(
        'sr-multiselect__option-item',
      );

      let isActive = false;
      for (let i = 0; i < inputOptionEl.length; i += 1) {
        if (inputOptionEl[i].classList.contains('active')) {
          isActive = true;
          break;
        }
      }

      if (isActive === true) {
        updatedFields += 1;
      }
    }

    return `${updatedFields}/${totalFields}`;
  };

  /**
   * @function
   * @param {HTMLElement} el - Form Field on which the
   * function/tracking is happening
   * @param {JSEvent} e
   * @param {int} index - Index of the form field
   */
  const handleInputTracking = (el, e, index) => {
    const elementItem = findElementItem();

    const recaptchaEl = formEl.querySelector('.g-recaptcha-custom:not(.hide)');
    let reCaptchaVersion = '';

    if (recaptchaEl) {
      [...recaptchaEl.classList].forEach((elClass) => {
        if (elClass === 'lazy-recaptcha-v3') {
          reCaptchaVersion = 'recaptcha-v3';
        } else if (elClass === 'lazy-recaptcha-v2') {
          reCaptchaVersion = 'recaptcha-v2';
        }
      });
    }

    const selectFieldEl = el.querySelector('.sr-select__value-input');
    const inputEl = el.querySelector('.form-input');

    /**
     * Check whether the selected field is a dropdown or an Input Element
     */
    const elementName = e.target?.name || inputEl?.name || selectFieldEl?.name;

    if (elementName) {
      window.GTMtracker.pushEvent({
        event: 'gtm_custom_click',
        data: {
          click_text: elementName,
          click_type: 'form-fields',
          click_position: index,
          product: 'RCB',
          click_source: 'midfunnel_rcb_form',
          click_item: elementItem,
          recaptcha_version: reCaptchaVersion,
        },
      });
    }
  };

  /**
   * Select all `form fields` which are not hidden
   */
  const inputEls = formEl.querySelectorAll('.form-field:not(.hidden)');

  for (let i = 0; i < multiSelectOption.length; i += 1) {
    multiSelectOption[i].addEventListener('click', (e) => {
      const elementItem = findElementItem();
      let dataInput = e.target.getAttribute('data-value');
      if (![...e.target.classList].includes('active')) {
        dataInput += ' checked';
      } else {
        dataInput += ' unchecked';
      }
      window.GTMtracker.pushEvent({
        event: 'gtm_custom_click',
        data: {
          click_text: dataInput,
          click_type: 'form-fields',
          click_position: '5',
          product: 'RCB',
          click_item: elementItem,
          recaptcha_version: 'reCaptchaVersion',
          form_value: e?.target?.value,
        },
      });
    });
  }

  if (inputEls) {
    [...inputEls].map((inputEl, index) => {
      inputEl.addEventListener('click', (
        event,
      ) => handleInputTracking(inputEl, event, index));
      return null;
    });
  }
};

const trackFilledFields = () => {
  const formEl = document.getElementById(formId);
  if (!formEl) {
    return;
  }
  // Select input elements with 'form-input' class
  const formInputEls = formEl?.querySelectorAll('input.form-input');
  [...formInputEls].forEach((ele) => {
    ele.addEventListener('blur', () => {
      onInputFilled(ele);
    });
  });

  // Select input elements with 'sr-select__value-input' class
  const selectInputEls = formEl?.querySelectorAll(
      'input.sr-select__value-input:not([name="country_code"])',
    );
  [...selectInputEls].forEach((ele) => {
    ele.addEventListener('input', () => {
      onInputFilled(ele);
    });
  });
};

const initializeTracking = () => {
  try {
    trackAllFormFields();
    trackFilledFields();
  } catch (e) {
    // Do nothing
  }
};

export default {
  formStatusTracking,
  initialize: initializeTracking,
  trackActivity,
};
